document.addEventListener('DOMContentLoaded', () => {
  if (!window.matchMedia('(max-width: 749px)').matches) return;

  document
    .querySelectorAll('media-gallery slideshow-component')
    .forEach((slideshow) => {
      const scroller = slideshow.querySelector('slideshow-slides');

      if (!scroller) return;

      let startX = 0;
      let startY = 0;
      let tracking = false;
      let suppressClick = false;

      scroller.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'touch') return;

        tracking = true;
        startX = event.clientX;
        startY = event.clientY;
      });

      scroller.addEventListener('pointerup', (event) => {
        if (!tracking || event.pointerType !== 'touch') return;

        tracking = false;

        const deltaX = event.clientX - startX;
        const deltaY = event.clientY - startY;

        /* Vertical gesture — let the page scroll normally */
        if (Math.abs(deltaY) > Math.abs(deltaX)) return;

        /* Ignore tiny horizontal movements */
        if (Math.abs(deltaX) < 40) return;

        suppressClick = true;

        if (deltaX < 0) {
          slideshow.next();
        } else {
          slideshow.previous();
        }
      });

      scroller.addEventListener('pointercancel', () => {
        tracking = false;
      });

      scroller.addEventListener(
        'click',
        (event) => {
          if (!suppressClick) return;

          event.preventDefault();
          event.stopImmediatePropagation();
          suppressClick = false;
        },
        true
      );
    });
});